export const FETCH_CONNECTIONS_REQUEST = "FETCH_CONNECTIONS_REQUEST";
export const FETCH_CONNECTIONS_SUCCESS = "FETCH_CONNECTIONS_SUCCESS";
export const FETCH_CONNECTIONS_FAILURE = "FETCH_CONNECTIONS_FAILURE";
export const APPEND_UNREAD_MESSAGES = "APPEND_UNREAD_MESSAGES";
export const CLEAR_UNREAD_MESSAGES = "CLEAR_UNREAD_MESSAGES";
export const UPDATE_TARGET = "UPDATE_TARGET";
export const MOVE_CONNECTION_AT_TOP = "MOVE_CONNECTION_AT_TOP";
